import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "previewImage",
    "fallback",
    "removeInput",
    "removeButton",
    "status"
  ]

  static values = {
    hasAvatar: Boolean
  }

  connect() {
    this.originalSrc = this.previewImageTarget.getAttribute("src") || ""
    this.pendingFile = false
    this.markedForRemoval = false
    this.refreshRemoveButton()
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    if (!file.type.startsWith("image/")) {
      this.clearPendingFile()
      this.setStatus("Selecione uma imagem válida.")
      return
    }

    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    this.pendingFile = true
    this.markedForRemoval = false
    this.removeInputTarget.value = "0"
    this.showImage(this.objectUrl)
    this.setStatus("Nova foto selecionada. Salve o perfil para aplicar.")
    this.refreshRemoveButton()
  }

  remove(event) {
    event.preventDefault()

    if (this.pendingFile) {
      this.clearPendingFile()
      this.restoreOriginalState()
      this.setStatus(this.hasAvatarValue ? "Seleção removida. A foto atual será mantida." : "Nenhuma foto selecionada.")
      return
    }

    this.markedForRemoval = this.hasAvatarValue
    this.removeInputTarget.value = this.markedForRemoval ? "1" : "0"
    this.hideImage()
    this.setStatus(this.markedForRemoval ? "A foto atual será removida ao salvar." : "Nenhuma foto para remover.")
    this.refreshRemoveButton()
  }

  clearPendingFile() {
    this.inputTarget.value = ""
    this.pendingFile = false
    this.revokeObjectUrl()
  }

  restoreOriginalState() {
    this.markedForRemoval = false
    this.removeInputTarget.value = "0"

    if (this.hasAvatarValue && this.originalSrc) {
      this.showImage(this.originalSrc)
    } else {
      this.hideImage()
    }

    this.refreshRemoveButton()
  }

  showImage(src) {
    this.previewImageTarget.src = src
    this.previewImageTarget.classList.remove("d-none")
    this.fallbackTarget.classList.add("d-none")
  }

  hideImage() {
    this.previewImageTarget.removeAttribute("src")
    this.previewImageTarget.classList.add("d-none")
    this.fallbackTarget.classList.remove("d-none")
  }

  refreshRemoveButton() {
    if (!this.hasRemoveButtonTarget) return

    const shouldShow = this.pendingFile || (this.hasAvatarValue && !this.markedForRemoval)
    this.removeButtonTarget.classList.toggle("d-none", !shouldShow)
  }

  setStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }

  revokeObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
